import React, { useEffect } from "react";
import cx from "clsx";
import styles from "./scss/Tarife.module.scss";
import { tarife } from "./tarife.consts";
import classesResponsive from "../../../src/components/Shared/scss/Responsive.module.scss";

const Tarife = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const styles = {
    heading: {
      textAlign: "center",
    },
    container: {
      margin: "20px",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    },
    header: {
      background: "rgb(175, 176, 132)",
      color: "white",
      padding: "10px",
      textAlign: "center",
      margin: 0,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      backgroundColor: "#f5f5f5",
      padding: "10px",
      borderBottom: "2px solid #ddd",
      textAlign: "left",
    },
    td: {
      padding: "10px",
      borderBottom: "1px solid #ddd",
    },
  };

  return (
    <div className={cx(styles.tarifeContainer, classesResponsive.paddingLeftRight)}>
      <h1 style={styles.heading}>Lista Preturi Stomatologice</h1>
      {Object.values(tarife).map((category, index) => {
        return (
          <div style={styles.container}>
            <h2 style={styles.header}>{category.label}</h2>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Denumire serviciu</th>
                  <th style={styles.th}>Preț</th>
                </tr>
              </thead>
              <tbody>
                {category.servicii.map((service, index) => (
                  <tr key={index}>
                    <td style={styles.td}>{service.name}</td>
                    <td style={styles.td}><b>{`${service.price} ron`}</b></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default Tarife;
